/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
* Defining global variables
**/
// const middlewareBaseUrl = 'https://rackmount-apac-drcda8f2eudsc5b4.westeurope-01.azurewebsites.net/'
const middlewareBaseUrl = 'https://rackmount-apac-drcda8f2eudsc5b4.westeurope-01.azurewebsites.net/';
/**
* Function to show the rack selector when clicking in the navigation
*/
function showRackSelector(e) {
  event.preventDefault()
  const rackModal = document.getElementById('rack-selector-popup');
  const mobileMenu = document.getElementById('mobile-menu-drawer');
  rackModal.setAttribute('open', true);
  mobileMenu.removeAttribute('open');
}

/**
* Banner Rack Selector
*/
/**
* Function to fetch the vendors for the rack selector when the page has loaded
*/
document.addEventListener("DOMContentLoaded", function () {
  // Get references to all select elements with the class 'rack-selector-brand'
  const vendorSelects = document.querySelectorAll(".rack-selector-brand");
  const loadingSpinner = document.getElementById("loading-spinner");
  const errorMessage = document.getElementById("rack-product-not-found");
  if(loadingSpinner) {
      loadingSpinner.style.display = "block";

  }
  
  // Make a request to the API
  fetch(middlewareBaseUrl + "rack-selector/fetch-vendors")
  .then(response => response.json())
  .then(data => {  
    errorMessage.style.display = "none";
    
    // Loop through each select element and fill it with options
    vendorSelects.forEach(vendorSelect => {
      data.forEach(optionValue => {
        const option = document.createElement("option");
        option.value = optionValue;
        option.textContent = optionValue;
        vendorSelect.appendChild(option);
      });
    });
  })
  .catch(error => console.error("Error fetching data:", error))
  .finally(() => {
    loadingSpinner.style.display = "none";
  });
});

/**
* Function to fetch the appliances based on the vendor choice once selected
*/
document.addEventListener("DOMContentLoaded", async function () {
  const vendorSelect = document.getElementById("rack-selector-brand");
  const applianceSelect = document.getElementById("rack-selector-model");
  const loadingSpinner = document.getElementById("loading-spinner");
  const errorMessage = document.getElementById("rack-product-not-found");
  if(vendorSelect) {
      vendorSelect.addEventListener("change", function () {
        console.log('changed')
    loadingSpinner.style.display = "block";
    const selectedValue = vendorSelect.value;
    // Fetch the list of appliances for the selected vendor
    fetch(middlewareBaseUrl + "rack-selector/filter-vendors?" + new URLSearchParams({
      vendor: selectedValue,
    }))
    .then((response) =>  response.json())
    .then(data => {
      errorMessage.style.display = "none";
      applianceSelect.innerHTML = "";
      data.forEach(optionValue => {
        console.log('option', optionValue);
        const option = document.createElement("option");
        option.value = optionValue;  // Assuming optionValue is the value you want to set
        option.textContent = optionValue[0];  // Assuming optionValue is the text content you want to display
        applianceSelect.appendChild(option);
      })
    })  
    .catch(error => console.error("Error fetching data:", error))
    .finally(() => {
      loadingSpinner.style.display = "none";
    });
  });
  }

});

/**
* Function to send the Rack Selector to the right place
*/
document.addEventListener("DOMContentLoaded", function () {
  const rackSelectorSubmitButton = document.getElementById('rack-selector-submit');
  const loadingSpinner = document.getElementById("loading-spinner");
  const errorMessage = document.getElementById("rack-product-not-found");

  if (rackSelectorSubmitButton) {
    rackSelectorSubmitButton.addEventListener("click", function () {
      let selectedApplianceValue = document.getElementById("rack-selector-model").value;
      if(selectedApplianceValue != "Sélectionnez d'abord une marque" 
         && selectedApplianceValue != "First select a brand" 
         && selectedApplianceValue != "Selecteer eerst merk" 
         && selectedApplianceValue != "Wählen Sie zunächst eine Marke aus"
         && selectedApplianceValue != "Marca de aparelho"
         && selectedApplianceValue != "Primero seleccione una marca"
         && selectedApplianceValue != "Per prima cosa seleziona una marca"
        ) {
            loadingSpinner.style.display = "block";

      // Normalize the locale for 'pt-PT' to 'pt'
      let locale = window.Shopify.locale === 'pt-PT' ? 'pt' : window.Shopify.locale;

      fetch(middlewareBaseUrl + "rack-selector/return-handle?" + new URLSearchParams({
        appliance_no: selectedApplianceValue,
      }))
      .then(response => response.json())
      .then(data => {
        if (data.message == 'Metaobject not found') {
          if (locale == 'en') {
            window.location.href = '/products/no-rack-needed';
          } else {
            window.location.href = '/' + locale + '/products/no-rack-needed';
          }
        } else if (data.message == 'Product in development') { 
          if (locale == 'en') {
            window.location.href = '/pages/product-in-development';
          } else {
            window.location.href = '/' + locale + '/pages/product-in-development';
          }
        } else {
          if (locale == 'en') {
            window.location.href = data;
          } else {
            window.location.href = '/' + locale + data;
          }
          errorMessage.style.display = "none";
        }
      })
      .catch(error => console.error("Error fetching data:", error))
      .finally(() => {
        loadingSpinner.style.display = "none";
      });
      } 
    });
  }
});


/**
* Header Rack Selector
*/
document.addEventListener("DOMContentLoaded", function () {
  // Get references to all select elements with the class 'rack-selector-brand'
  const vendorSelectsHeader = document.querySelectorAll(".rack-selector-header-brand");
  const loadingSpinner = document.getElementById("header-loading-spinner");
  const errorMessage = document.getElementById("rack-product-header-not-found");

  loadingSpinner.style.display = "block";
  
  // Make a request to the API
  fetch(middlewareBaseUrl + "rack-selector/fetch-vendors")
  .then(response => response.json())
  .then(data => {  
    errorMessage.style.display = "none";
    
    // Loop through each select element and fill it with options
    vendorSelectsHeader.forEach(vendorSelect => {
      data.forEach(optionValue => {
        const option = document.createElement("option");
        option.value = optionValue;
        option.textContent = optionValue;
        vendorSelect.appendChild(option);
      });
    });
  })
  .catch(error => console.error("Error fetching data:", error))
  .finally(() => {
    loadingSpinner.style.display = "none";
  });
});

/**
* Function to fetch the appliances based on the vendor choice once selected
*/
document.addEventListener("DOMContentLoaded", function () {
  const vendorSelect = document.getElementById("rack-selector-header-brand");
  const applianceSelect = document.getElementById("rack-selector-header-model");
  const loadingSpinner = document.getElementById("header-loading-spinner");
  const errorMessage = document.getElementById("rack-product-header-not-found");

  vendorSelect.addEventListener("change", function () {
    loadingSpinner.style.display = "block";
    const selectedValue = vendorSelect.value;
    // Fetch the list of appliances for the selected vendor
    fetch(middlewareBaseUrl + "rack-selector/filter-vendors?" + new URLSearchParams({
      vendor: selectedValue,
    }))
    .then(response => response.json())
    .then(data => {
      errorMessage.style.display = "none";
      applianceSelect.innerHTML = "";
      data.forEach(optionValue => {
        console.log('option', optionValue);
        const option = document.createElement("option");
        option.value = optionValue;  // Assuming optionValue is the value you want to set
        option.textContent = optionValue[0];  // Assuming optionValue is the text content you want to display
        applianceSelect.appendChild(option);
      })
    })  
    .catch(error => console.error("Error fetching data:", error))
    .finally(() => {
      loadingSpinner.style.display = "none";
    });
  });
});

/**
* Function to send the Rack Selector to the right place
*/
document.addEventListener("DOMContentLoaded", function () {
  const rackSelectorSubmitButton = document.getElementById('rack-selector-header-submit');
  const loadingSpinner = document.getElementById("header-loading-spinner");
  const errorMessage = document.getElementById("rack-product-header-not-found");

  rackSelectorSubmitButton.addEventListener("click", function () {
    let selectedApplianceValue = document.getElementById("rack-selector-header-model").value;
    if(selectedApplianceValue != "Sélectionnez d'abord une marque" 
         && selectedApplianceValue != "First select a brand" 
         && selectedApplianceValue != "Selecteer eerst merk" 
         && selectedApplianceValue != "Wählen Sie zunächst eine Marke aus"
         && selectedApplianceValue != "Marca de aparelho"
         && selectedApplianceValue != "Primero seleccione una marca"
         && selectedApplianceValue != "Per prima cosa seleziona una marca"
        ) {
            loadingSpinner.style.display = "block";
    // Normalize the locale for 'pt-PT' to 'pt'
    let locale = window.Shopify.locale === 'pt-PT' ? 'pt' : window.Shopify.locale;

    fetch(middlewareBaseUrl + "rack-selector/return-handle?" + new URLSearchParams({
      appliance_no: selectedApplianceValue,
    }))
    .then(response => response.json())
    .then(data => {
      
      if(data.message == 'Metaobject not found') {
        if(locale == 'en') {
          window.location.href = '/products/no-rack-needed'
        } else {
          window.location.href = '/' + locale + '/products/no-rack-needed'
        }
      } else if (data.message == 'Product in development') { 
        if(locale == 'en') {
          window.location.href = '/pages/product-in-development'
        } else {
          window.location.href = '/' + locale + '/pages/product-in-development'
        }
      } else {
        if(locale == 'en') {
          window.location.href = data;
        } else {
          window.location.href = '/' + locale + data;
        }
        errorMessage.style.display = "none";
      }
    })
    .catch(error => console.error("Error fetching data:", error))
    .finally(() => {
      loadingSpinner.style.display = "none";
    });
    }
  })
})


/**
* Functions to upload files on the return form
*/
function handleFiles(files) {
    var gallery = document.getElementById("gallery");
    
    for (var i = 0; i < files.length; i++) {
        console.log('files', files)
        var file = files[i];
        var imageType = /^image\//;

        if (!imageType.test(file.type)) {
            continue;
        }

        var img = document.createElement("img");
        img.classList.add("obj");
        img.file = file;
        gallery.appendChild(img);

        var reader = new FileReader();

        reader.addEventListener("load", (function(aImg) {
            return function(e) {
                aImg.src = e.target.result;
            };
        })(img));

        reader.readAsDataURL(file);
    }
}

function highlightDropArea() {
    var dropArea = document.getElementById("drop-area");
    dropArea.classList.add("highlight");
}

function unhighlightDropArea() {
    var dropArea = document.getElementById("drop-area");
    dropArea.classList.remove("highlight");
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById("return_form")) {
    // Get the form element
    var form = document.getElementById('return_form'); // Replace 'yourFormId' with the actual ID of your form

  // Create a new input element
  var newInput = document.createElement('input');
  
  // Set the attributes of the input element
  newInput.type = 'hidden'; // You can set the type to 'hidden' if you don't want the field to be visible
  newInput.name = 'fieldName'; // Replace 'fieldName' with the name you want for your field
  newInput.value = 'fieldValue'; // Replace 'fieldValue' with the value you want for your field
  
  // Append the input element to the form
  form.appendChild(newInput);
    
    document.getElementById("drop-area").addEventListener("dragover", function(event) {
        event.preventDefault();
        highlightDropArea();
    });
    
    document.getElementById("drop-area").addEventListener("dragleave", function(event) {
        event.preventDefault();
        unhighlightDropArea();
    });
    
    // document.getElementById("drop-area").addEventListener("drop", function(event) {
    //     event.preventDefault();
    //     unhighlightDropArea();
    //     var files = event.dataTransfer.files;
    //     handleFiles(files);
    // });
    
    // document.getElementById("fileElem").addEventListener("change", function(event) {
    //     var files = event.target.files;
    //     handleFiles(files);
    // });
  }
})


if (document.getElementById("file-upload")) {
  document.getElementById("file-upload").addEventListener("click", async function(event) {
    event.preventDefault();
    
    var formData = new FormData();
    var files = document.getElementById("fileElem").files;
        for (var i = 0; i < files.length; i++) {
        var file = files[i];
        formData.append("images", file, file.name); // Append file with its name
    }

    // Send formData to your Node.js application using fetch or XMLHttpRequest
    // Example using fetch:
    fetch(middlewareBaseUrl + "files/upload-file", {
        method: "POST",
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        console.log("Upload successful:", data);
        let container = document.getElementById('uploaded-files');

        data.forEach(function(item, index) {
          
           let input = document.createElement('input');

            input.type = 'text';
            input.value = item.originalSource;
            input.name = 'contact[uploaded-image_' + index + ']'; // You can use any naming convention here
  
            container.appendChild(input);
        })
        document.getElementById('file-upload-success-message').style.display = 'block';
    })
    .catch(error => {
        console.error("Error uploading:", error);
        document.getElementById('file-upload-error-message').style.display = 'block';
        // Handle errors
    });
  });
}

// Showing the login popup
function showCartModal() {
  const cartModal = document.getElementById('cart-modal');
  cartModal.setAttribute('open', true);
  setTimeout(function() {
    window.location.href="https://rackmountit-apac-production.myshopify.com/pages/b2b-register"  
  }, 5000)
}

const b2bCartButton = document.getElementById('cart-b2b-modal');
if (b2bCartButton) {
// Add a click event listener
  b2bCartButton.addEventListener('click', function(e) {
    alert('clicked')
    e.preventDefault();
    showCartModal();
  });
}
